import { TerminateTransfer } from '@features/ForestOwner/EditShareOwnership/TerminateTransfer/TerminateTransfer'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate/useTranslations'
import { z } from 'zod'

const searchSchema = z.object({
  isEstateSettlement: z.coerce.boolean().optional().default(false),
})
export const Route = createFileRoute(
  '/forestowner/$forestownerId/shareownership/editShareOwnership/terminateTransfer/',
)({
  component: RouteComponent,
  validateSearch: searchSchema,
  staticData: {
    breadcrumb: t('forestowner-editshareownership-terminatetransfer.title'),
  },
})

function RouteComponent() {
  const search = Route.useSearch()
  return <TerminateTransfer isEstateSettlement={search.isEstateSettlement} />
}
